import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_error",
  "use": "icon-icon_error-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_error\">\n  <path d=\"M620.8 512l358.4-360.533c29.867-29.867 29.867-78.934 0-108.8s-78.933-29.867-108.8 0L512 403.2 151.467 44.8c-29.867-29.867-78.934-29.867-108.8 0s-29.867 78.933 0 108.8L403.2 512 44.8 872.533c-29.867 29.867-29.867 78.934 0 108.8s78.933 29.867 108.8 0L512 620.8l360.533 360.533c29.867 29.867 78.934 29.867 108.8 0s29.867-78.933 0-108.8L620.8 512z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/admin/icons/svg/icon_error.svg
// module id = 8xXA
// module chunks = 8